import styled, { keyframes } from 'styled-components';
import * as defines from '../../../utils/defines/Defines';

export const Container = styled.div`
	background: ${defines.BackgroundColor};
	width: 100vw;
	height: 100vh;
	padding: 80px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	position: relative;
`;

export const Title = styled.h1`
	font-family: 'Comfortaa';
	font-weight: 400;
	color: #000;
	font-size: 80px;
`;

export const SubTitle = styled.h3`
	font-family: 'Comfortaa';
	font-weight: normal;
	color: #000;
	font-size: 25px;
`;

export const Row = styled.div`
	display: flex;
	grid-gap: 0px 10px;
	align-items: center;
	flex-wrap: wrap;
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	grid-gap: 10px 0px;
	align-items: left;
`;

export const Circle = styled.div`
	width: 10px;
	height: 10px;
	background: #000;
	border-radius: 10px;
`;

export const TitleCompany = styled.h2<{ color: string }>`
	font-family: 'Signa';
	font-weight: black;
	font-style: italic;
	font-size: 25px;
	color: ${(props) => props.color};
`;

const TextAnimate = keyframes`
    from{
        margin-top: -10px;
        opacity: 0;
    }
    to{
        margin-top: 0px;
        opacity: 1;
    }
`;

export const TextError = styled.a`
	font-family: 'Comfortaa';
	font-size: 10px;
	color: ${defines.Red};
	animation: 0.35s ${TextAnimate} ease-in;
`;

export const Text = styled.a`
	font-family: 'Comfortaa';
	font-size: 12px;
	color: #000;
	max-width: 300px;
	word-wrap: break-word;
`;

export const TextDisabled = styled.a`
	font-family: 'Comfortaa';
	font-size: 12px;
	color: #838383;
	max-width: 300px;
	word-wrap: break-word;
`;

export const ButtonTitle = styled.a`
	font-family: 'Comfortaa';
	font-size: 16px;
	font-weight: bold;
	color: #000;
	max-width: 300px;
	word-wrap: break-word;
`;

export const ButtonTitleDisabled = styled.a`
	font-family: 'Comfortaa';
	font-size: 16px;
	font-weight: bold;
	color: #838383;
	max-width: 300px;
	word-wrap: break-word;
`;

const CardAnimate = keyframes`
    from{
        right: -10vw;
        opacity: 0;
    }
    to{
        right: 80px;
        opacity: 1;
    }
`;

export const CardLogin = styled.div`
	position: absolute;
	width: 500px;
	border-radius: 20px;
	padding: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	grid-gap: 15px 0px;
	animation: 0.5s ${CardAnimate} ease-in;
	transition: 0.5s;
	-webkit-box-shadow:
		10px 10px 30px 1px rgba(211, 211, 212, 0.4),
		-10px -10px 30px 1px rgba(255, 255, 255, 0.8);
	box-shadow:
		-10px -10px 30px 1px rgba(255, 255, 255, 0.8),
		10px 10px 30px 1px rgba(211, 211, 212, 0.4);
	right: 80px;
`;

export const Card = styled.div`
	width: 100%;
	border-radius: 20px;
	padding: 15px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	box-sizing: border-box;
	grid-gap: 15px 0px;
	animation: 0.5s ${CardAnimate} ease-in;
	transition: 0.5s;
	background: white;

	&:hover {
		background: #ebebeb;
	}
`;

export const CardDisabled = styled.div`
	width: 100%;
	border-radius: 20px;
	padding: 15px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	box-sizing: border-box;
	grid-gap: 15px 0px;
	animation: 0.5s ${CardAnimate} ease-in;
	transition: 0.5s;
	background: #e0e0e0;
`;

export const Icon = styled.img`
	margin-right: 15px;
	width: 47px;
	z-index: 3;
`;

export const BtnGrad = styled.div`
	background-image: linear-gradient(
		to right,
		rgb(62, 147, 216) 0%,
		rgb(76, 185, 49) 100%
	);
	width: 100%;
	border-radius: 20px;
	padding: 15px;
	display: flex;
	flex-direction: column;
	align-items: center; /* Changed from flex-start to center */
	box-sizing: border-box;
	grid-gap: 15px 0px;
	animation: 0.5s ${CardAnimate} ease-in;
	transition: 0.5s;
	background-size: 200% auto;
	color: white;
	box-shadow: 0 0 20px #eee;
	border-radius: 10px;
	display: block;

	&:hover {
		background-position: right center; /* change the direction of the change here */
		color: #fff;
		text-decoration: none;
	}
`;

export const ButtonTitleWhite = styled.a`
	font-family: 'Comfortaa';
	font-weight: 400;
	color: white;
	font-size: 16px;
`;

export const TextWhite = styled.a`
	font-family: 'Comfortaa';
	font-size: 12px;
	color: white;
	max-width: 300px;
	word-wrap: break-word;
`;

export const CompanyLogo = styled.img`
	height: 20px;
`;
